import { render, staticRenderFns } from "./ActivatedServices.vue?vue&type=template&id=0814e5d9&"
import script from "./ActivatedServices.vue?vue&type=script&lang=js&"
export * from "./ActivatedServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports